import { SalaryIncreasePlaceholder } from "../components/SalaryIncreasePlaceholder";

export default function BuApprovalPage() {
  return (
    <SalaryIncreasePlaceholder
      title="BU Approval"
      description="Review and approve allocations for your business unit."
    />
  );
}
